import { render } from "./TopicCardComponent.vue?vue&type=template&id=688e3846"
import script from "./TopicCardComponent.vue?vue&type=script&lang=js"
export * from "./TopicCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__